(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["custom-line-art-preview"] && !Shopify.designMode) return;
  try {
    (() => {
    const findParentUpload = (container) => {
      const form = container.closest('form');
      return Array.from(form?.querySelectorAll('input[type="file"][name^="properties["]') || [])
        .find((input) => !input.disabled);
    };

    const updateOriginalPreview = (container, upload) => {
      const photo = upload?.files?.[0];
      const preview = container.querySelector('[data-pe-original-preview]');
      if (!preview) return;
      if (!photo) {
        if (container.pePreviewUrl) URL.revokeObjectURL(container.pePreviewUrl);
        container.pePreviewFile = null;
        container.pePreviewUrl = '';
        preview.removeAttribute('src');
        return;
      }
      if (container.pePreviewFile === photo) return;
      if (container.pePreviewUrl) URL.revokeObjectURL(container.pePreviewUrl);
      container.pePreviewFile = photo;
      container.pePreviewUrl = URL.createObjectURL(photo);
      preview.src = container.pePreviewUrl;
    };

    const updateUploadControl = (container, upload) => {
      if (!upload?.id) return;
      const form = container.closest('form');
      const label = form?.querySelector(`label[for="${CSS.escape(upload.id)}"]`);
      if (!label) return;
      if (!label.dataset.peOriginalLabel) label.dataset.peOriginalLabel = label.textContent.trim();
      label.textContent = label.dataset.peOriginalLabel;
      label.classList.add('pe-photo-upload-control');
      let fileName = upload.parentElement?.querySelector('[data-pe-upload-file-name]');
      if (!fileName) {
        fileName = document.createElement('span');
        fileName.className = 'pe-photo-upload-file-name';
        fileName.dataset.peUploadFileName = '';
        fileName.setAttribute('aria-live', 'polite');
        upload.insertAdjacentElement('afterend', fileName);
      }
      const photo = upload.files?.[0];
      fileName.textContent = photo?.name || '';
      fileName.hidden = !photo;
    };

    const prepareFrame = (frame, container) => {
      const frameDocument = frame.contentDocument;
      const frameWindow = frame.contentWindow;
      const parentUpload = findParentUpload(container);
      const localUpload = frameDocument?.getElementById('fileInput');
      if (!frameDocument || !frameWindow || !parentUpload || !localUpload) return;

      const difficulty = frameDocument.getElementById('difficulty');
      if (difficulty) difficulty.value = container.dataset.pePreviewMode || 'easy';

      frameDocument.documentElement.style.background = '#fdfcf9';
      frameDocument.body.style.background = '#fdfcf9';
      frameWindow.alert = (message) => {
        if (!String(message).includes('Image loaded successfully')) window.alert(message);
      };

      if (!frame.photoBridge || frame.photoBridge.source !== parentUpload) {
        let syncing = false;
        const transferPhoto = (source, destination) => {
          const photo = source.files?.[0];
          if (!photo || syncing) return;
          syncing = true;
          const transfer = new DataTransfer();
          transfer.items.add(photo);
          destination.files = transfer.files;
          destination.dispatchEvent(new Event('change', { bubbles: true }));
          syncing = false;
        };
        const syncToPreview = () => transferPhoto(parentUpload, localUpload);
        const syncToOrder = () => transferPhoto(localUpload, parentUpload);
        parentUpload.addEventListener('change', syncToPreview);
        localUpload.addEventListener('change', syncToOrder);
        frame.photoBridge = { source: parentUpload, syncToPreview };
      }

      if (parentUpload.files?.length) frame.photoBridge.syncToPreview();
    };

    const loadGenerator = async (frame, container) => {
      if (frame.dataset.generatorLoaded || frame.dataset.generatorLoading) return;
      frame.dataset.generatorLoading = 'true';
      frame.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(frame.dataset.generatorUrl, { credentials: 'same-origin' });
        if (!response.ok) throw new Error(`Generator request failed: ${response.status}`);
        const source = await response.text();
        const parsed = new DOMParser().parseFromString(source, 'text/html');
        const generator = parsed.getElementById('btnGenerate')?.closest('.wrap');
        const generatorStyle = Array.from(parsed.querySelectorAll('style')).find((style) => style.textContent.includes('--paper:#fdfcf9'));
        const generatorScript = Array.from(parsed.querySelectorAll('script')).find((script) => script.textContent.includes('const TARGET_W = 2400'));
        if (!generator || !generatorStyle || !generatorScript) throw new Error('Generator markup was not found');

        const previewStyle = `<style>
          html,body{margin:0!important;background:#fdfcf9!important;overflow:auto}
          .wrap{display:block!important;max-width:none!important;margin:0!important;padding:16px!important}
          .left{display:none!important}
          .right{display:block!important;min-width:0!important;width:100%!important}
          .right>.title,#previewOutline{display:none!important}
          #previewColor{display:block!important;width:100%!important;height:auto!important;border:0!important;border-radius:8px!important;background:#f8f6f1!important;image-rendering:auto!important}
        </style>`;
        const optimizedScript = generatorScript.textContent
          .replace('const PREVIEW_W = 1000;', 'const PREVIEW_W = 2400;')
          .replace("const K = diff==='easy'?12:diff==='medium'?24:36;", "const K = diff==='easy'?24:diff==='medium'?36:48;")
          .replace('const LINE_RGBA = [246,185,116,255];', 'const LINE_RGBA = [156,117,78,255];')
          .replace('const NUM_RGBA  = [242,168,92,255];', 'const NUM_RGBA  = [118,86,52,255];')
          .replace(
            `img.onload=()=>{ baseImg=img; alert("✅ Image loaded successfully! Click 'Generate Template' to continue."); };`,
            `img.onload=()=>{ baseImg=img; btnGenerate.click(); };`
          )
          .replace(
            'wctxColor.drawImage(baseImg,0,0,P_W,P_H);',
            `wctxColor.filter='blur(2px)';wctxColor.drawImage(baseImg,0,0,P_W,P_H);wctxColor.filter='none';`
          )
          .replace('for(let y=1;y<P_H-1;y++){', 'for(let y=2;y<P_H-2;y++){')
          .replace('for(let x=1;x<P_W-1;x++){', 'for(let x=2;x<P_W-2;x++){')
          .replace(
            'if(here!==indexMap[i-1]||here!==indexMap[i+1]||here!==indexMap[i-P_W]||here!==indexMap[i+P_W]){',
            'if(here!==indexMap[i-1]||here!==indexMap[i+1]||here!==indexMap[i-P_W]||here!==indexMap[i+P_W]||here!==indexMap[i-2]||here!==indexMap[i+2]||here!==indexMap[i-(P_W*2)]||here!==indexMap[i+(P_W*2)]){'
          )
          .replace(
            'd[p]=255;d[p+1]=255;d[p+2]=255;d[p+3]=255;',
            'const tint=palette[here];d[p]=Math.round(253*0.88+tint[0]*0.12);d[p+1]=Math.round(252*0.88+tint[1]*0.12);d[p+2]=Math.round(249*0.88+tint[2]*0.12);d[p+3]=255;'
          )
          .replace("diff==='hard'?'28px Arial':diff==='medium'?'32px Arial':'36px Arial'", "diff==='hard'?'38px Arial':diff==='medium'?'42px Arial':'46px Arial'")
          .replace(
            'renderPreviews();',
            `renderPreviews();window.parent.postMessage({type:'pe-color-preview-ready',mode:difficultySel.value},'*');`
          );

        frame.addEventListener('load', () => {
          prepareFrame(frame, container);
          frame.removeAttribute('aria-busy');
        }, { once: true });
        frame.srcdoc = `<!doctype html><html lang="en"><head><meta charset="UTF-8"><meta name="viewport" content="width=device-width, initial-scale=1">${generatorStyle.outerHTML}${previewStyle}</head><body>${generator.outerHTML}<script>${optimizedScript}<\/script></body></html>`;
        frame.dataset.generatorLoaded = 'true';
      } catch (error) {
        frame.removeAttribute('aria-busy');
        console.error(error);
      } finally {
        delete frame.dataset.generatorLoading;
      }
    };

    const initialize = () => {
      document.querySelectorAll('[data-pe-line-art-preview]:not([data-pe-line-art-ready])').forEach((container) => {
        const dialog = container.querySelector('[data-pe-line-art-dialog]');
        if (!dialog) return;

        const refreshAvailability = () => {
          const parentUpload = findParentUpload(container);
          const hasPhoto = Boolean(parentUpload?.files?.length);
          container.hidden = !hasPhoto;
          updateOriginalPreview(container, parentUpload);
          requestAnimationFrame(() => updateUploadControl(container, parentUpload));
          if (!hasPhoto && !dialog.hidden) {
            dialog.hidden = true;
            container.querySelector('[data-pe-line-art-open]')?.setAttribute('aria-expanded', 'false');
          }
          if (hasPhoto && !dialog.hidden) {
            const frame = dialog.querySelector('[data-generator-url]');
            if (!frame) return;
            if (frame.dataset.generatorLoaded) prepareFrame(frame, container);
            else loadGenerator(frame, container);
          }
        };

        const selectMode = (button) => {
          if (container.classList.contains('is-generating')) return;
          const frame = dialog.querySelector('[data-generator-url]');
          const frameDocument = frame?.contentDocument;
          const difficulty = frameDocument?.getElementById('difficulty');
          const generate = frameDocument?.getElementById('btnGenerate');
          if (!difficulty || !generate) return;
          container.dataset.pePreviewMode = button.dataset.pePreviewMode;
          container.querySelectorAll('[data-pe-preview-mode]').forEach((tab) => {
            tab.setAttribute('aria-selected', String(tab === button));
          });
          const paletteLabel = container.querySelector('[data-pe-palette-label]');
          if (paletteLabel) {
            paletteLabel.textContent = paletteLabel.dataset.labelTemplate.replace('__COUNT__', button.dataset.pePreviewCount);
          }
          difficulty.value = button.dataset.pePreviewMode;
          container.classList.add('is-generating');
          generate.click();
        };

        container.dataset.peLineArtReady = 'true';
        container.dataset.pePreviewMode = 'easy';
        container.peRefreshAvailability = refreshAvailability;
        container.querySelector('[data-pe-line-art-open]')?.addEventListener('click', () => {
          const frame = dialog.querySelector('[data-generator-url]');
          if (frame) {
            if (frame.dataset.generatorLoaded) prepareFrame(frame, container);
            else loadGenerator(frame, container);
          }
          container.classList.add('is-generating');
          dialog.hidden = false;
          container.querySelector('[data-pe-line-art-open]')?.setAttribute('aria-expanded', 'true');
          dialog.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        });
        container.querySelectorAll('[data-pe-preview-mode]').forEach((button) => {
          button.addEventListener('click', () => selectMode(button));
        });
        window.addEventListener('message', (event) => {
          const frame = dialog.querySelector('[data-generator-url]');
          if (event.source !== frame?.contentWindow || event.data?.type !== 'pe-color-preview-ready') return;
          container.classList.remove('is-generating');
          const paletteSource = frame.contentDocument?.getElementById('paletteBox');
          const paletteTarget = container.querySelector('[data-pe-palette-content]');
          if (paletteSource && paletteTarget) paletteTarget.innerHTML = paletteSource.innerHTML;
        });
        const closePreview = () => {
          dialog.hidden = true;
          const openButton = container.querySelector('[data-pe-line-art-open]');
          openButton?.setAttribute('aria-expanded', 'false');
          openButton?.focus();
        };
        container.querySelectorAll('[data-pe-line-art-close]').forEach((button) => {
          button.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            closePreview();
          });
        });
        dialog.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') closePreview();
        });
        refreshAvailability();
      });
    };

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
    else initialize();
    document.addEventListener('shopify:section:load', initialize);
    document.addEventListener('change', (event) => {
      const upload = event.target;
      if (!(upload instanceof HTMLInputElement) || upload.type !== 'file') return;
      const form = upload.closest('form');
      if (!form) return;
      initialize();
      form.querySelectorAll('[data-pe-line-art-preview]').forEach((container) => {
        container.peRefreshAvailability?.();
      });
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["painteasy-gift-addon"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('painteasy-gift-addon')) {
    customElements.define('painteasy-gift-addon', class extends HTMLElement {
      connectedCallback() {
        this.form = document.getElementById(this.dataset.formId);
        this.checkbox = this.querySelector('[data-pe-gift-addon-checkbox]');
        this.error = this.querySelector('[data-pe-gift-addon-error]');
        this.bypass = false;
        this.busy = false;
        if (!this.form || !this.checkbox) return;
        this.form.addEventListener('submit', this.onSubmit, true);
      }

      disconnectedCallback() {
        this.form?.removeEventListener('submit', this.onSubmit, true);
      }

      onSubmit = async (event) => {
        if (this.bypass) {
          this.bypass = false;
          return;
        }
        if (!this.checkbox.checked || this.busy) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.busy = true;
        this.error.hidden = true;
        const submitter = event.submitter || this.form.querySelector('[data-atc-form]');
        try {
          const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ items: [{ id: Number(this.dataset.variantId), quantity: 1 }] })
          });
          if (!response.ok) throw new Error('Gift add-on unavailable');
          this.bypass = true;
          this.form.requestSubmit(submitter);
        } catch (error) {
          this.error.hidden = false;
        } finally {
          this.busy = false;
        }
      };
    });
  }
  } catch(e) { console.error(e); }
})();

})();
